<div class="page-sub-title">Create Practice Template</div>

<div class="padded-container margin-top-large">
  <p>
    <label for="drillLabel">Template Name</label>
    <input
      id="templateLabel"
      type="text"
      class="input full-width"
      placeholder="Ex: Short Game Practice"
      [(ngModel)]="template.label"
      name="templateLabel"
      autocapitalize="words"
    />
  </p>

    <p>
        <label>Selected Drills</label>
    </p>
    <div class="table-container">
        <table>
                <thead>
                    <tr>
                        <th>Drill</th>
                        <th># Reps</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let d of selectedDrills">
                        <td>{{ d.drill.label }}</td>
                        <td style="max-width: 60px; text-align: right;">
                            <input
                                type="text"
                                class="input full-width"
                                [(ngModel)]="d.number_of_reps"
                                />
                        </td>
                        <td><button class="btn-small btn">X</button></td>
                    </tr>
                </tbody>
            </table>
    </div>




  <p>
    <label>Available Drills</label>
</p>
<div class="table-container">
     <table>
            <thead></thead>
            <tbody>
                <tr *ngFor="let d of unselectedDrills">
                    <td>{{ d.drill.label }}</td>
                    <td>{{ d.drill.club_label }}</td>
                    <td><button class="btn-small btn-green" (click)="selectDrill(d)">Select</button></td>
                </tr>
            </tbody>
        </table>
</div>

  <p>
    <button class="btn btn-green btn-full-width margin-top-large" (click)="saveTempate()">
      Save Template
    </button>
  </p>
</div>